import { BrowserRouter, Route, Routes } from "react-router-dom";
import Report from './pages/report';
import Login from './pages/login';
import Dashboard from './pages/dashboard';
import Profile from './pages/profile';
import Market from './pages/market-watch';
import StatementofFinancialHoldings from './pages/statement-of-financial-holding-pdf';
import StatementofFinancialHoldings1 from './pages/statement-of-financial-holding-pdf2';
import InvestmentAccountActivityReport from './pages/Investment-account-activity-report-pdf1';
import RealizedGainorLoss from './pages/realized-gain-loss-pdf';
import Transactiondetails from './pages/transaction-details-pdf';
import Changepwd from './pages/change-pwd';
import IdleTimeout from "./pages/idleTimeout "
import Notification from "./pages/notifications"
import TermsAndConditions from "./pages/terms-and-conditions"
import PrivacyPolicy from "./pages/privacy-policy"
import RiskAndDisclosure from "./pages/risk-and-disclosure"

import Margin from "../src/pages/financial-holding";
import NonMargin from "../src/pages/statement-financial-holding";
import ActivityReport from "../src/pages/activity-report";
import TransactionDetails from "../src/pages/transaction-details";
import GainLoss from "../src/pages/gain-loss";
export default function PageNavigations() {
    return (
        <BrowserRouter>
            <IdleTimeout />
            <Routes>
                {/* <Route path="/reports" element={<Report />} /> */}

                <Route path="/reports/marginPortfolio" element={<Margin />} />
                <Route path="/reports/nonMarginPortfolio" element={<NonMargin />} />
                <Route path="/reports/cashReport" element={<ActivityReport />} />
                <Route path="/reports/transaction" element={<TransactionDetails />} />
                <Route path="/reports/realized" element={<GainLoss />} />

                <Route path="/change-password" element={<Changepwd />} />

                <Route path="/" element={<Login />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/my-profile" element={<Profile />} />
                <Route path="/market" element={<Market />} />
                <Route path="/investment-account-activity-report" element={<InvestmentAccountActivityReport />} />
                <Route path="/margin-client-holding-template" element={<StatementofFinancialHoldings />} />
                <Route path="/non-margin-client-holding-template" element={<StatementofFinancialHoldings1 />} />
                <Route path="/realizedGL-template" element={<RealizedGainorLoss />} />
                <Route path="/transaction-details-template" element={<Transactiondetails />} />
                <Route path="/notifications" element={<Notification />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/risk-and-disclosure" element={<RiskAndDisclosure />} />
            </Routes>
        </BrowserRouter>
    )
}